import { emailRegex, rfcRegex, fileNameRegex, curpRegex, nssRegex } from './RegexValidations';
import * as yup from 'yup';

export const emailSchema = yup
  .string()
  .required('Completa este campo')
  .max(255)
  .matches(emailRegex, 'Correo electrónico inválido');
export const clientNameSchema = yup.string().required('Completa este campo').max(255);
export const tinSchema = yup
  .string()
  .required('Completa este campo')
  .matches(rfcRegex, 'RFC inválido');
export const selectSchema = yup.string().required('Completa este campo');
export const entityTypeSchema = yup
  .string()
  .required('Selecciona una opción')
  .oneOf(['PERSONA FISICA', 'PERSONA MORAL'], 'Selecciona una opción');

export const stageTypeSchema = yup
  .string()
  .required('Selecciona una opción')
  .oneOf(
    [
      'Positiva / Negativa / Fecha',
      'Positiva / Negativa',
      'Ejecución por Fecha',
      'Archivos',
      'Archivos / Fecha',
      'Ejecución',
    ],
    'Selecciona una opción',
  );

export const responsibleEntitieSchema = yup
  .string()
  .required('Selecciona una opción')
  .oneOf(['USUARIO', 'CLIENTE'], 'Selecciona una opción');
export const phoneNumberSchema = yup
  .string()
  .required('Completa este campo')
  .min(14, 'Número de teléfono inválido');
export const BooleanSchema = yup.number().transform((value) => (value ? 1 : 0));
export const DaySchema = yup.string('Tiene que ser un día válido').required('Completa este campo');
export const fileNameSchema = yup
  .string()
  .required('Completa este campo')
  .matches(fileNameRegex, 'Nombre de archivo inválido')
  .max(255, 'Nombre de archivo máximo de 255 caracteres.');
export const yesNoRadioSchema = yup
  .string()
  .required('Completa este campo')
  .oneOf(['0', '1'], 'Selección no válida');

export const serviceAreaSchema = yup
  .string()
  .required('Selecciona un elemento')
  .oneOf(['Contabilidad', 'Auditoria', 'Asesoria', 'Nomina'], 'Selecciona un elemento');
export const creditTypeSchema = yup
  .string()
  .required('Selecciona un elemento')
  .oneOf(['INFONAVIT', 'FONACOT'], 'Selecciona un elemento');

export const conditionalCreditTypeSchema = yup.array().when('is_credit_active', {
  is: true,
  then: (schema) =>
    schema
      .required('Selecciona al menos un elemento')
      .min(1, 'Selecciona al menos un elemento')
      .of(
        yup.object().shape({
          name: yup.string().oneOf(['INFONAVIT', 'FONACOT'], 'Selecciona un elemento válido'),
        }),
      ),
  otherwise: (schema) => schema.nullable(),
});

export const conditionalPaymentTypeSchema = yup.string().when('isActivePaysheet', {
  is: (val) => val === true || val === 1,
  then: (schema) =>
    schema
      .required('Selecciona un elemento')
      .oneOf(['Quincenal', 'Catorcenal', 'Semanal'], 'Selecciona un elemento válido'),
  otherwise: (schema) => schema.nullable(),
});

export const curpSchema = yup
  .string()
  .required('Completa este campo')
  .matches(curpRegex, 'CURP inválido');

export const nssSchema = yup
  .string()
  .required('Completa este campo')
  .matches(nssRegex, 'NSS inválido');

export const userTypeSchema = yup
  .string()
  .required('Selecciona un elemento')
  .oneOf(['Administrador', 'Auditor', 'Operador', 'Cliente'], 'Selecciona un elemento');
export const startPaydate = yup.string().when('isActivePaysheet', {
  is: (val) => val === true || val === 1,
  then: (schema) => schema.required('La fecha de pago es requerida'),
  otherwise: (schema) => schema.nullable(),
});

export const incidenceTypeSchema = yup.string().required('Selecciona un elemento');

export const toDateSchema = yup.string().when('is_date_range', {
  is: true,
  then: (schema) => schema.required('Completa este campo'),
  otherwise: (schema) => schema.nullable(),
});

export const schemas = {
  BooleanSchema,
  clientNameSchema,
  tinSchema,
  entityTypeSchema,
  fileNameSchema,
  phoneNumberSchema,
  emailSchema,
  selectSchema,
  stageTypeSchema,
  responsibleEntitieSchema,
  DaySchema,
  yesNoRadioSchema,
  serviceAreaSchema,
  userTypeSchema,
  creditTypeSchema,
  conditionalCreditTypeSchema,
  conditionalPaymentTypeSchema,
  curpSchema,
  nssSchema,
  startPaydate,
};
